import { FC } from 'react';
import {
  SingleEtfAssetTrendNavChart,
  SingleFundAssetTrendNavChart,
} from './components';
import { useGetFundDetailsByQuery } from '@/modules/invest/subModules/fund/hooks/useGetFundDetails';

export const SingleAssetTrend: FC = () => {
  const { fundDetails } = useGetFundDetailsByQuery();

  if (!fundDetails?.fundHistory) {
    return null;
  }

  return (
    <>
      {fundDetails.fundType === 'FUND' ? (
        <SingleFundAssetTrendNavChart />
      ) : (
        <SingleEtfAssetTrendNavChart />
      )}
    </>
  );
};
